// Operational display only. Never use this value for payloads, scaling, or costing.
const normalUnit = unit => String(unit || "").trim().toLowerCase();
const countUnits = ["piece", "pieces", "pc", "pcs", "each", "unit"];
const preciseUnits = ["g", "gram", "grams", "ml", "millilitre", "milliliter", "millilitres", "milliliters"];
const kitchenFractions = [[1 / 8, "1/8"], [1 / 6, "1/6"], [1 / 4, "1/4"], [1 / 3, "1/3"], [1 / 2, "1/2"], [2 / 3, "2/3"], [3 / 4, "3/4"]];
const tidy = (value, places) => String(Number(value.toFixed(places)));

export const formatKitchenQuantity = (quantity, unit) => {
  const value = Number(quantity);
  if (!Number.isFinite(value)) return "—";
  const magnitude = Math.abs(value);
  const normalized = normalUnit(unit);
  if (countUnits.includes(normalized)) {
    const whole = Math.trunc(Math.abs(value)); const remainder = Math.abs(value) - whole;
    const nearest = kitchenFractions.reduce((best, candidate) => Math.abs(candidate[0] - remainder) < Math.abs(best[0] - remainder) ? candidate : best);
    // Fractions are presentation only; snap only when genuinely close.
    if (Math.abs(nearest[0] - remainder) <= 0.015) return `${value < 0 ? "-" : ""}${whole ? `${whole} ${nearest[1]}` : nearest[1]}`;
    return tidy(value, magnitude < 1 ? 2 : 1);
  }
  if (preciseUnits.includes(normalized)) {
    if (magnitude < 5) return tidy(value, 2);
    if (magnitude <= 20) return tidy(value, 1);
    return tidy(value, 0);
  }
  return tidy(value, 3);
};

export const formatKitchenAmount = (quantity, unit) => {
  const normalized = normalUnit(unit);
  const displayUnit = countUnits.includes(normalized) ? "pc" : unit;
  return `${formatKitchenQuantity(quantity, unit)}${displayUnit ? ` ${displayUnit}` : ""}`;
};
